import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { AddIcon } from 'foundations-assets/icons/components/AddIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = suffix => `formsLegalText.configurationPanel.${suffix}`;
const AddConsentCheckboxButton = ({
  onClick,
  disabled
}) => /*#__PURE__*/_jsxs(Link, {
  onClick: onClick,
  disabled: disabled,
  "data-action": "create-communication-consent-checkbox",
  children: [/*#__PURE__*/_jsx(AddIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
    message: i18nKey('addConsentCheckbox')
  })]
});
export default AddConsentCheckboxButton;